import { fromJS, Map } from 'immutable';

import {
  createNewReturn,
  // requestReturnDetails,
  requestUnsubmittedReturnDetails,
  requestReturnsById,
  requestSubmittedReturns,
  setIsReturnStep,
  setReturnData,
  setOriginatesFromReturnStatus,
  submitReturn,
  setSelectedReturnId,
  clearPreviousReturnStepData,
  updateReturnDetails
} from './actions';

const defaultState = Map({
  isFetching: false,
  isSubmitting: false,
  isReturnStep: false,
  createReturnResponse: {},
  returnData: {},
  originatesFromReturnStatus: false,
  orderReturnDetails: {},
  selectedReturnId: '',
  submittedReturns: null,
  detailUpdate: false,
  submittedReturnDetails: []
});

export default function orderReturns(state = defaultState, action) {
  const newState = fromJS(state);

  switch (action.type) {
    case createNewReturn.event.start:
      return newState.set('isFetching', true);

    case createNewReturn.event.success:
      return newState.withMutations(state => {
        state.set('isFetching', false).set('createReturnResponse', action.payload);
      });

    case createNewReturn.event.error:
      return newState.set('isFetching', false);

    // case requestReturnDetails.event.start:
    //   return newState.withMutations(state => {
    //     state.set('isFetching', true).set('orderReturnDetails', {});
    //   });
    //
    // case requestReturnDetails.event.success:
    //   return newState.withMutations(state => {
    //     state.set('isFetching', false).set('orderReturnDetails', action.payload);
    //   });
    //
    // case requestReturnDetails.event.error:
    //   return newState.withMutations(state => {
    //     state.set('isFetching', false).set('orderReturnDetails', action.payload);
    //   });

    case requestUnsubmittedReturnDetails.event.start:
      return newState.withMutations(state => {
        state.set('isFetching', true).set('orderReturnDetails', {});
      });

    case requestUnsubmittedReturnDetails.event.success:
      return newState.withMutations(state => {
        state.set('isFetching', false).set('orderReturnDetails', action.payload);
      });

    case requestUnsubmittedReturnDetails.event.error:
      return newState.withMutations(state => {
        state.set('isFetching', false).set('orderReturnDetails', {});
      });

    case requestSubmittedReturns.event.start:
      return newState.set('submittedReturns', null);
    case requestSubmittedReturns.event.success:
      return newState.set('submittedReturns', action.payload);
    case requestSubmittedReturns.event.error:
      return newState.set('submittedReturns', null);

    case setIsReturnStep.type:
      return newState.set('isReturnStep', action.payload);

    case setReturnData.type:
      return newState.set('returnData', action.payload);

    case setOriginatesFromReturnStatus.type:
      return newState.set('originatesFromReturnStatus', action.payload);

    case submitReturn.event.start:
      return newState.set('isSubmitting', true);
    case submitReturn.event.error:
    case requestReturnsById.event.error:
      return newState.set('isSubmitting', false);
    case requestReturnsById.event.success:
      return newState.set('isSubmitting', false).set('submittedReturnDetails', action.payload.objects);

    case setSelectedReturnId.type:
      return newState.set('selectedReturnId', action.payload);

    case clearPreviousReturnStepData.type:
      return newState.withMutations(state => {
        state.set('createReturnResponse', {}).set('orderReturnDetails', {});
      });

    case updateReturnDetails.event.start:
      return newState.set('detailUpdate', true);
    case updateReturnDetails.event.success:
      return newState.set('detailUpdate', false);
    case updateReturnDetails.event.error:
      return newState.set('detailUpdate', false);

    default:
      return newState;
  }
}

export const isFetching = state => state.orderReturns.get('isFetching');
export const detailUpdate = state => state.orderReturns.get('detailUpdate');
export const isSubmitting = state => state.orderReturns.get('isSubmitting');
export const isReturnStep = state => state.orderReturns.get('isReturnStep');
export const getReturnCreateResponse = state => state.orderReturns.get('createReturnResponse');
export const getReturnData = state => state.orderReturns.get('returnData');
export const originatesFromReturnStatus = state => state.orderReturns.get('originatesFromReturnStatus');
export const getOrderReturnDetails = state => state.orderReturns.get('orderReturnDetails');
export const selectedReturnId = state => state.orderReturns.get('selectedReturnId');
export const submittedReturns = state => state.orderReturns.get('submittedReturns');
export const getSubmittedReturnDetails = state => state.orderReturns.get('submittedReturnDetails');
